export const isSafari = (userAgent: string = navigator.userAgent) =>
  /^((?!chrome|android).)*safari/i.test(userAgent)
